export const mainGreen = '#008848'
export const mainRed = '#d32f2f'
export const mainBlue = '#006c9c'
export const mainPurple = '#850f8d'
export const mainGrey = '#f4f4f6'
export const borderFormat = '1px solid #C4CDD5'
export const successColor = 'success'
export const errorColor = 'error'
